let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8g6U0")).then(() => parcelRequire('03tlj'));